import { useTranslation } from "react-i18next";

import NavSideLink from "@src/components/nav/NavSideLink";
import NavSideLinkList, { ListType } from "@src/components/nav/NavSideLinkList";

type Props = {
  isMobile?: boolean;
  onClose?: () => void;
  linkIndex: string;
  setLinkIndex: (index: string) => void;
};
type NavItem = ListType | { groupTitle: string };

const NavSideUser = ({ isMobile = false, onClose, linkIndex = "", setLinkIndex }: Props) => {
  const { t } = useTranslation();
  function isGroupTitle(item: NavItem): item is { groupTitle: string } {
    return "groupTitle" in item;
  }
  return (
    <div className="top-[52px] z-10 w-full border-gray-300">
      <div className="flex flex-col gap-2.5">
        {NavSideLinkList(t).map(item =>
          isGroupTitle(item) ? (
            <div key={`group-${item.groupTitle}`} className="mt-2">
              <h4 className="flex text-xs font-semibold text-black">{item.groupTitle}</h4>
              <hr className="my-2 border-gray-200" />
            </div>
          ) : (
            <NavSideLink
              link={item}
              key={item.href}
              isMobile={isMobile}
              onClose={onClose}
              linkIndex={linkIndex}
              setLinkIndex={newIndex => setLinkIndex(newIndex)}
            />
          ),
        )}
      </div>
    </div>
  );
};

export default NavSideUser;
